import { ErrorMessageContents } from '../../../helpers/hub'
import { TierList } from './types'

export const tierFetch = (editable: boolean) =>
  ({ type: 'tiers.fetch', payload: editable } as const)
type TierFetchAction = ReturnType<typeof tierFetch>

export const tierAddTier = (tiers: TierList[]) =>
  ({ type: 'tiers.addTiers', payload: tiers } as const)
type TierAddTierAction = ReturnType<typeof tierAddTier>

export const tierFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'tiers.fetchFail', payload: error, error: true } as const)
type TierFetchFailAction = ReturnType<typeof tierFetchFail>

export const saveTier = (tl: TierList) =>
  ({ type: 'tiers.saveTier', payload: tl } as const)
export type TierSaveAction = ReturnType<typeof saveTier>

export const revertTier = (id: number) =>
  ({ type: 'tiers.revertTier', payload: id } as const)
export type TierRevertAction = ReturnType<typeof revertTier>

export const saveTierSuccess = (tierList: TierList, transactionId?: number) =>
  ({
    type: 'tiers.saveTierSuccess',
    payload: { tierList, transactionId }
  } as const)
type SaveTierSuccessAction = ReturnType<typeof saveTierSuccess>

export const revertTierSuccess = (id: number, transactionId?: number) =>
  ({
    type: 'tiers.revertTierSuccess',
    payload: { id, transactionId }
  } as const)

export const saveTierFailure = (error: ErrorMessageContents) =>
  ({
    type: 'tiers.saveTierFailure',
    payload: error,
    error: true
  } as const)
type SaveTierFailureAction = ReturnType<typeof saveTierFailure>

export type TierAction =
  | TierFetchAction
  | TierAddTierAction
  | TierFetchFailAction
  | TierSaveAction
  | SaveTierSuccessAction
  | SaveTierFailureAction
  | TierRevertAction
